import { ContactDetails } from '../../types';

export interface SerializedSession {
  id: string;
  createdAt: number;
  lastSeenAt: number;
  contacts: ContactDetails[];
  metadata: Record<string, unknown>;
}

class Session implements SerializedSession {
  id: string;

  createdAt: number;

  lastSeenAt: number;

  contacts: ContactDetails[];

  metadata: Record<string, unknown>;

  constructor(session?: SerializedSession) {
    this.id = session?.id ?? Math.random().toString(36).substring(2, 15);
    this.createdAt = session?.createdAt ?? Date.now();
    this.lastSeenAt = session?.lastSeenAt ?? Date.now();
    this.contacts = session?.contacts ?? [];
    this.metadata = {};
  }

  keepActive() {
    this.lastSeenAt = Date.now();
  }

  serialize(): SerializedSession {
    return {
      id: this.id,
      createdAt: this.createdAt,
      lastSeenAt: this.lastSeenAt,
      contacts: this.contacts,
      metadata: this.metadata,
    };
  }

  addContacts(contacts: ContactDetails[]) {
    this.contacts = [...this.contacts, ...contacts];
  }

  addMetadata(metadata: Record<string, unknown>) {
    this.metadata = {
      ...this.metadata,
      ...metadata,
    };
    return this;
  }
}

export default Session;
